<template>
  <ul class="item-container clearfix">
    <li class="item-box info-container">
      <div class="item title">广州锐动网络科技有限公司</div>
      <div class="item text">具体服务内容以双方书面确认为准。</div>
      <div class="item path">地址：广州市天河区黄村三联路12号B2栋一楼B1097</div>
      <div class="item tel">联系电话：18998835053</div>
      <div class="item mail">邮箱：2996762481@qq.com</div>
      <div class="item btn-box">
        <a href="tel:18998835053">电话联系</a>
        <a href="mailto:2996762481@qq.com">邮件留言</a>
      </div>
    </li>
  </ul>
</template>

<script>
export default {};
</script>


<style lang="less" scoped>
.item-box {
  width: 100%;
  float: left;
  padding: 20px 0;
  @media (max-width: 768px) {
    & {
      width: 100%;
      text-align: center;
    }
  }
}

.info-container {
  padding: 20px;

  .item {
    font-size: 14px;
    padding: 10px 0;
  }

  .title {
    font-size: 20px;
    font-weight: bold;
  }

  .btn-box {
    padding-top: 20px;
  }

  .btn-box > a {
    display: inline-block;
    background-color: #007eff;
    color: #fff;
    padding: 10px 30px;
    margin-right: 20px;
    border-radius: 3px;
    cursor: pointer;
    text-decoration: none;
  }
}
</style>
